import React from 'react';
import {Avatar, Box, Button, List, ListItem, ListItemButton, Sheet, Stack} from '@mui/joy';
import { Facebook, GitHub, Instagram, LinkedIn, Twitter, YouTube } from "@mui/icons-material";
import {SummaryModel} from "../model/summary";

function SocialNetwork( {summary}: { summary: SummaryModel }) {
    const sectionFollow = {
        items: [
            {
                name: "Facebook",
                to: summary.facebook,
                logo: <Facebook sx={{fontSize:24}} />
            },
            {
                name: "Instagram",
                to: summary.instagram,
                logo: <Instagram sx={{fontSize:24}}/>
            },
            {
                name: "Twitter",
                to: summary.twitter,
                logo: <Twitter sx={{fontSize:24}}/>
            },
            {
                name: "GitHub",
                to: summary.github,
                logo: <GitHub sx={{fontSize:24}}/>
            },
            {
                name: "Youtube",
                to: summary.youtube,
                logo: <YouTube sx={{fontSize:24}}/>
            },
            {
                name: "LinkedIn",
                to: summary.linkedin,
                logo: <LinkedIn sx={{fontSize:24}}/>
            },
        ]
    };
    return (
        <Stack direction='row' spacing={1} alignItems={{ md: "start", xs: "start" }} >
                {sectionFollow.items.map((item) => (
                    <a
                        key={item.name}
                        href={item.to}
                        target="_blank"
                        rel="noreferrer"
                        style={{ textDecoration: "none", padding: 0 }} >
                            {item.logo}
                    </a>
                ))}
        </Stack>
    );
}

export default SocialNetwork;
